// Generated by purs version 0.15.15
import * as Control_Category from "../Control.Category/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var options = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform,
        unwrapSingleConstructors: true,
        unwrapSingleRecordArguments: true
    };
})();
var defaultEnumEncode = function (dictGeneric) {
    var genericEncodeEnum = Foreign_Generic_EnumEncoding.genericEncodeEnum(dictGeneric);
    return function (dictGenericEncodeEnum) {
        var genericEncodeEnum1 = genericEncodeEnum(dictGenericEncodeEnum);
        return function (x) {
            return genericEncodeEnum1({
                constructorTagTransform: identity
            })(x);
        };
    };
};
var defaultEnumDecode = function (dictGeneric) {
    var genericDecodeEnum = Foreign_Generic_EnumEncoding.genericDecodeEnum(dictGeneric);
    return function (dictGenericDecodeEnum) {
        var genericDecodeEnum1 = genericDecodeEnum(dictGenericDecodeEnum);
        return function (x) {
            return genericDecodeEnum1({
                constructorTagTransform: identity
            })(x);
        };
    };
};
var defaultEncodeJSON = function (dictGeneric) {
    var genericEncodeJSON = Foreign_Generic.genericEncodeJSON(dictGeneric);
    return function (dictGenericEncode) {
        var genericEncodeJSON1 = genericEncodeJSON(dictGenericEncode);
        return function (x) {
            return genericEncodeJSON1(options)(x);
        };
    };
};
var defaultEncode = function (dictGeneric) {
    var genericEncode = Foreign_Generic.genericEncode(dictGeneric);
    return function (dictGenericEncode) {
        var genericEncode1 = genericEncode(dictGenericEncode);
        return function (x) {
            return genericEncode1(options)(x);
        };
    };
};
var defaultDecodeJSON = function (dictGeneric) {
    var genericDecodeJSON = Foreign_Generic.genericDecodeJSON(dictGeneric);
    return function (dictGenericDecode) {
        var genericDecodeJSON1 = genericDecodeJSON(dictGenericDecode);
        return function (x) {
            return genericDecodeJSON1(options)(x);
        };
    };
};
var defaultDecode = function (dictGeneric) {
    var genericDecode = Foreign_Generic.genericDecode(dictGeneric);
    return function (dictGenericDecode) {
        var genericDecode1 = genericDecode(dictGenericDecode);
        return function (x) {
            return genericDecode1(options)(x);
        };
    };
};
export {
    defaultDecode,
    defaultEncode,
    defaultEnumDecode,
    defaultEnumEncode,
    defaultDecodeJSON,
    defaultEncodeJSON
};
